import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import { ConfigContext } from '../config-provider';
import Icon from '../icon';
import classNames from 'classnames';

var Content = function Content(args) {
  var _context;

  var title = args.title,
      footer = args.footer,
      content = args.content,
      closable = args.closable,
      suffixCls = args.suffixCls,
      contentClose = args.contentClose,
      showIcon = args.showIcon,
      type = args.type,
      icon = args.icon,
      closeNode = args.closeNode;

  var _useContext = useContext(ConfigContext),
      prefixCls = _useContext.prefixCls;

  var classPrefix = _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, suffixCls, "-content");

  var iconMap = {
    info: /*#__PURE__*/React.createElement(Icon, {
      type: "warning-solid"
    }),
    primary: /*#__PURE__*/React.createElement(Icon, {
      type: "warning-solid"
    })
  };

  var renderIcon = function renderIcon() {
    if (icon) return /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-title-left-icon"))
    }, icon);
    if (!showIcon) return null;
    return iconMap[type] ? /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-title-left-icon"))
    }, iconMap[type]) : null;
  };

  var renderCloseIcon = function renderCloseIcon() {
    if (!closable) return null;

    if (closeNode) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "-title-close"),
        onClick: contentClose
      }, closeNode);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-title-close"),
      onClick: contentClose
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    }));
  };

  var getTitleElement = function getTitleElement() {
    if (typeof title === null) {
      return null;
    }

    if ( /*#__PURE__*/React.isValidElement(title)) {
      return title;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-title"))
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-title-left"))
    }, renderIcon(), /*#__PURE__*/React.createElement("div", {
      className: classNames("".concat(classPrefix, "-title-left-text"))
    }, title)), renderCloseIcon());
  };

  var getFooterElement = function getFooterElement() {
    if ( /*#__PURE__*/React.isValidElement(footer)) {
      return footer;
    }

    if (Array.isArray(footer)) {
      var arr = footer;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(classPrefix, "-footer"))
      }, _mapInstanceProperty(arr).call(arr, function (_ref) {
        var name = _ref.name,
            _onClick = _ref.onClick;

        if (name) {
          return /*#__PURE__*/React.createElement("div", {
            key: name,
            onClick: function onClick(e) {
              if (e) {
                e.stopPropagation();
              }

              _onClick && _onClick();
            }
          }, /*#__PURE__*/React.createElement("div", null, name));
        }

        return null;
      }));
    }

    return null;
  };

  var getMainElement = function getMainElement() {
    if (typeof content === 'string') {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(classPrefix, "-description"))
      }, content);
    }

    if ( /*#__PURE__*/React.isValidElement(content)) {
      return content;
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, getTitleElement(), getMainElement(), getFooterElement());
};

export default Content;